export default __webpack_public_path__ + "static/cert4-42045145f5a2c951febe7f0543d8fd88.jpg";